var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.131 22.792h-5.29m0 0h-5.035m5.034 0v6.27m-5.034-6.27H2.995a1.256 1.256 0 0 1-1.259-1.253V7.746c0-.692.564-1.254 1.259-1.254h22.656c.695 0 1.259.562 1.259 1.254v8.08m-15.104 6.966v6.27m5.034 0h1.952m-1.952 0h-5.034m0 0H9.563m14.056-13.236h6.096c.526 0 .952.488.952 1.09v11.152c0 .602-.427 1.09-.953 1.09H23.62c-.526 0-.952-.488-.952-1.09V16.916c0-.602.426-1.09.952-1.09"
  })));
};
export default SvgDevices;